import React, { Component } from "react";
import {
  Container,
  Form,
  Row,
  Col,
  Button,
  Tab,
  Tabs,
  Card,
  Modal,
  Table,
  ButtonGroup,
} from "react-bootstrap";
import Timekeeper from "react-timekeeper";
import Stepper from "react-stepper-horizontal";
import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import { appConfig } from "../../config";
import Navbar from "../../components/Navbar/Navbar";
import PlacesAutocomplete, {
  geocodeByAddress,
  getLatLng,
} from "react-places-autocomplete";
import TimePicker from "react-time-picker";
import "./profileupdate.css";
import { node } from "prop-types";

class UpdateProfile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: true,

      steps: [
        { title: "Business Details" },
        { title: "Location" },
        { title: "Working days" },
        { title: "Bank Details" },
      ],
      currentstep: 0,

      orgname: "",
      weburl: "",
      storeEmail: "",
      mobile: "",
      licencenum: "",
      licencenum2: "",
      gst: "",
      contPerson: "",
      fileImg: "",
      file: "",
      credit: "",
      homedelivery: false,

      location: "",
      lat: "",
      longi: "",
      addr1: "",
      addr2: "",
      landmark: "",
      city: "",
      zip: "",
      states: "",
      district: "",

      workingHrs: {
        mon: {
          isWorking: false,
          open: "09:00",
          close: "18:00",
          openmin: 540,
          closemin: 1080,
          showDay: "Monday",
        },
        tue: {
          isWorking: false,
          open: "09:00",
          close: "18:00",
          openmin: 540,
          closemin: 1080,
          showDay: "Tuesday",
        },
        wed: {
          isWorking: false,
          open: "09:00",
          close: "18:00",
          openmin: 540,
          closemin: 1080,
          showDay: "Wednesday",
        },
        thu: {
          isWorking: false,
          open: "09:00",
          close: "18:00",
          openmin: 540,
          closemin: 1080,
          showDay: "Thursday",
        },
        fri: {
          isWorking: false,
          open: "09:00",
          close: "18:00",
          openmin: 540,
          closemin: 1080,
          showDay: "Friday",
        },
        sat: {
          isWorking: false,
          open: "09:00",
          close: "18:00",
          openmin: 540,
          closemin: 1080,
          showDay: "Saturday",
        },
        sun: {
          isWorking: false,
          open: "09:00",
          close: "18:00",
          openmin: 540,
          closemin: 1080,
          showDay: "Sunday",
        },
      },

      duplicateworkingHrs: {
        mon: {},
        tue: {},
        wed: {},
        thu: {},
        fri: {},
        sat: {},
        sun: {},
      },

      bankName: "",
      acholderName: "",
      acType: "",
      acNo: "",
      ifsc: "",
      branchName: "",
      branchAddr: "",

      orgnameError: "",
      storeEmailError: "",
      mobileError: "",
      licencenumError: "",
      licencenum2Error: "",
      gstError: "",
      contPersonError: "",
      addr1Error: "",
      cityError: "",
      statesError: "",
      districtError: "",
      zipError: "",
      bankNameError: "",
      acholderNameError: "",
      acTypeError: "",
      acNoError: "",
      ifscError: "",
      branchNameError: "",
      hydratedOrgProfileId: "",
    };
  }

  componentDidMount() {
    if ("geolocation" in navigator) {
      console.log("Available");
    } else {
      console.log("Not Available");
    }

    let user = JSON.parse(localStorage.getItem("userDetails"));
    console.log(user);

    this.props.fetchStates();
    this.props.fetchbanks();

    if (user && user.role === "employee") {
      if (user.distributor) {
        this.props.fetchOrgProfile(user.distributor);
      }
    }
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.orgProfile &&
      this.props.orgProfile !== prevProps.orgProfile &&
      this.props.orgProfile.id !== this.state.hydratedOrgProfileId
    ) {
      this.hydrateOrgProfile(this.props.orgProfile);
    }
  }

  getTimeFromMinutes = (minutes) => {
    if (minutes === undefined || minutes === null) {
      return "09:00";
    }

    const hrs = Math.floor(minutes / 60)
      .toString()
      .padStart(2, "0");
    const mins = (minutes % 60).toString().padStart(2, "0");
    return `${hrs}:${mins}`;
  };

  mapWorkingHours = (workingHrs = {}) => {
    const defaultWorkingHrs = this.state.workingHrs;

    return Object.keys(defaultWorkingHrs).reduce((acc, day) => {
      const currentDay = workingHrs[day] || {};
      const open = currentDay.open;
      const close = currentDay.close;
      const isWorking = open !== undefined && close !== undefined;

      acc[day] = {
        ...defaultWorkingHrs[day],
        isWorking,
        open: isWorking ? this.getTimeFromMinutes(open) : defaultWorkingHrs[day].open,
        close: isWorking ? this.getTimeFromMinutes(close) : defaultWorkingHrs[day].close,
        openmin: isWorking ? open : defaultWorkingHrs[day].openmin,
        closemin: isWorking ? close : defaultWorkingHrs[day].closemin,
      };

      return acc;
    }, {});
  };

  hydrateOrgProfile = (orgProfile) => {
    const stateId =
      orgProfile.state && typeof orgProfile.state === "object"
        ? orgProfile.state.id
        : orgProfile.state || "";
    const districtId =
      orgProfile.district && typeof orgProfile.district === "object"
        ? orgProfile.district.id
        : orgProfile.district || "";
    const bankId =
      orgProfile.bankName && typeof orgProfile.bankName === "object"
        ? orgProfile.bankName.id
        : orgProfile.bankName || "";
    const geo = Array.isArray(orgProfile.geo) ? orgProfile.geo : [];
    const workingHrs = this.mapWorkingHours(orgProfile.workingHrs);

    this.setState({
      orgname: orgProfile.name || "",
      weburl: orgProfile.website || "",
      storeEmail: orgProfile.email || "",
      mobile: orgProfile.mobile || "",
      licencenum: orgProfile.licenceNo || "",
      licencenum2: orgProfile.drugLicense || "",
      gst: orgProfile.gstin || "",
      contPerson: orgProfile.contactPersn || "",
      fileImg: orgProfile.imgUrl || "",
      credit: orgProfile.crdtPeriod || "",
      location: orgProfile.addr1 || "",
      lat: geo[1] || "",
      longi: geo[0] || "",
      addr1: orgProfile.addr1 || "",
      addr2: orgProfile.addr2 || "",
      landmark: orgProfile.landmark || "",
      city: orgProfile.city || "",
      zip: orgProfile.zip || "",
      states: stateId,
      district: districtId,
      bankName: bankId,
      acholderName: orgProfile.acntName || "",
      acType: orgProfile.acntType || "",
      acNo: orgProfile.acntNo || "",
      ifsc: orgProfile.ifscCode || "",
      branchName: orgProfile.brchName || "",
      branchAddr: orgProfile.brchAddr || "",
      workingHrs,
      duplicateworkingHrs: orgProfile.workingHrs || {
        mon: {},
        tue: {},
        wed: {},
        thu: {},
        fri: {},
        sat: {},
        sun: {},
      },
      flag: orgProfile.addr1 ? 1 : this.state.flag,
      hydratedOrgProfileId: orgProfile.id,
    });

    if (stateId) {
      this.props.fetchDistricts(stateId);
    }
  };

  //For closing the modal box
  closeModal = () => {
    document.getElementById("overlayDiv").style.display = "none";
    this.setState({
      ...this.state,
      showModal: false,
    });
  };

  onChange = (e) => {
    let val = e.target.value;
    let name = e.target.name;

    if (name === "orgName") {
      this.setState({
        ...this.state,
        orgname: val,
        orgnameError: "",
      });
    } else if (name === "licenceNum") {
      this.setState({
        ...this.state,
        licencenum: val,
        licencenumError: "",
      });
    } else if (name === "licenceNum2") {
      this.setState({
        ...this.state,
        licencenum2: val,
        licencenum2Error: "",
      });
    } else if (name === "webSite") {
      this.setState({
        ...this.state,
        weburl: val,
      });
    } else if (name === "storeEmail") {
      this.setState({
        ...this.state,
        storeEmail: val,
        storeEmailError: "",
      });
    } else if (name === "contPerson") {
      this.setState({
        ...this.state,
        contPerson: val,
        contPersonError: "",
      });
    } else if (name === "mobile") {
      this.setState({
        ...this.state,
        mobile: val,
        mobileError: "",
      });
    } else if (name == "addr2") {
      this.setState({
        ...this.state,
        addr2: val,
      });
    } else if (name === "homedel") {
      this.setState({
        ...this.state,
        homedelivery: val,
      });
    } else if (name === "landmark") {
      this.setState({
        ...this.state,
        landmark: val,
      });
    } else if (name === "city") {
      this.setState({
        ...this.state,
        city: val,
        cityError: "",
      });
    } else if (name === "zip") {
      this.setState({
        ...this.state,
        zip: val,
        zipError: "",
      });
    } else if (name === "states") {
      this.setState(
        {
          ...this.state,
          states: val,
          statesError: "",
        },
        () => {
          this.props.fetchDistricts(val);
        },
      );
    } else if (name === "district") {
      // alert(val);
      this.setState({
        ...this.state,
        district: val,
        districtError: "",
      });
    } else if (name === "credit") {
      // alert(val);
      this.setState({
        ...this.state,
        credit: val,
      });
    } else if (name === "gstin") {
      this.setState({
        ...this.state,
        gst: val,
        gstError: "",
      });
    } else if (name === "banks") {
      this.setState({
        ...this.state,
        bankName: val,
        bankNameError: "",
      });
    } else if (name === "acholderName") {
      this.setState({
        ...this.state,
        acholderName: val,
        acholderNameError: "",
      });
    } else if (name === "actype") {
      this.setState({
        ...this.state,
        acType: val,
        acTypeError: "",
      });
    } else if (name === "acno") {
      this.setState({
        ...this.state,
        acNo: val,
        acNoError: "",
      });
    } else if (name === "ifsc") {
      this.setState({
        ...this.state,
        ifsc: val,
        ifscError: "",
      });
    } else if (name === "branchname") {
      this.setState({
        ...this.state,
        branchName: val,
        branchNameError: "",
      });
    } else if (name === "branchaddr") {
      this.setState({
        ...this.state,
        branchAddr: val,
      });
    }
  };

  ontimeChange = (val, day, status, inMinutes) => {
    //For conversion to minutes
    let hours = val.substring(0, 2);
    let min = val.substring(3, 5);
    let timeinMinutes = +(hours * 60) + +min; //Using unary plus operators to avoid concatenation;

    this.setState((prevState) => ({
      ...prevState,
      workingHrs: {
        ...prevState.workingHrs,
        [day]: {
          ...prevState.workingHrs[day],
          [status]: val,
          [inMinutes]: timeinMinutes,
        },
      },
    }));
  };

  oncheckChange = (e, day) => {
    let isChecked = e.target.checked;

    this.setState((prevState) => ({
      ...prevState,
      workingHrs: {
        ...prevState.workingHrs,
        [day]: {
          ...prevState.workingHrs[day],
          isWorking: isChecked,
        },
      },
    }));
  };

  //Related to the placesautocomplete plugin
  handleSelect = async (value) => {
    const results = await geocodeByAddress(value);
    const latLng = await getLatLng(results[0]);

    this.setState({
      ...this.state,
      location: value,
      flag: 1,
      locationError: "",
      addr1: results[0].formatted_address,
      lat: latLng.lat,
      longi: latLng.lng,
    });
  };

  onLocationChange = (value) => {
    this.setState({
      ...this.state,
      location: value,
      flag: 0,
      addr1: value,
      addr1Error: "",
    });
  };

  validatebusiness = () => {
    const {
      orgname,
      storeEmail,
      mobile,
      licencenum,
      licencenum2,
      gst,
      contPerson,
    } = this.state;
    let isError = false;

    let regex =
      /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;
    let gstregex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
    let mobreg = /^[0-9]{10}$/;
    let namereg = /^[a-zA-Z]/;

    const errmsg = "This field cannot be empty";
    const errmsg1 = "Please enter a valid email";
    const errmsg2 = "Entered GST is not in valid format";
    const errmsg3 = "Please enter a valid mobile number";
    const errmsg4 = "Please enter a name";

    const errors = {
      orgnameError: "",
      storeEmailError: "",
      mobileError: "",
      licencenumError: "",
      licencenum2Error: "",
      gstError: "",
      contPersonError: "",
    };

    if (orgname === "") {
      isError = true;
      errors.orgnameError = errmsg;
    }
    if (storeEmail === "") {
      isError = true;
      errors.storeEmailError = errmsg;
    }
    if (this.state.storeEmail !== "" && !regex.test(this.state.storeEmail)) {
      isError = true;
      errors.storeEmailError = errmsg1;
    }
    if (mobile === "") {
      isError = true;
      errors.mobileError = errmsg;
    }
    if (mobile !== "" && !mobreg.test(mobile)) {
      isError = true;
      errors.mobileError = errmsg3;
    }
    if (licencenum === "") {
      isError = true;
      errors.licencenumError = errmsg;
    }
    if (licencenum2 === "") {
      isError = true;
      errors.licencenum2Error = errmsg;
    }
    if (gst === "") {
      isError = true;
      errors.gstError = errmsg;
    }
    if (gst !== "" && !gstregex.test(gst)) {
      isError = true;
      errors.gstError = errmsg2;
    }
    if (contPerson === "") {
      isError = true;
      errors.contPersonError = errmsg;
    }
    if (contPerson !== "" && !namereg.test(contPerson)) {
      isError = true;
      errors.contPersonError = errmsg4;
    }

    this.setState({
      ...this.state,
      ...errors,
    });

    return isError;
  };

  validatelocation = () => {
    const { addr1, city, states, district, zip } = this.state;

    let isError = false;

    let zipreg = /^[0-9]{6}$/;

    const errmsg = "Please select a location";
    const errmsg3 = "Please enter a city";
    const errmsg1 = "Please select a state";
    const errmsg2 = "Please select a district";
    const errmsg4 = "This field can't be empty";
    const errmsg5 = "Enter a valid pincode";

    const errors = {
      addr1Error: "",
      cityError: "",
      statesError: "",
      districtError: "",
      zipError: "",
      locationError: "",
    };

    if (addr1 === "") {
      isError = true;
      errors.addr1Error = errmsg;
    }
    if (city === "") {
      isError = true;
      errors.cityError = errmsg3;
    }
    if (states === "") {
      isError = true;
      errors.statesError = errmsg1;
    }
    if (district === "") {
      isError = true;
      errors.districtError = errmsg2;
    }
    if (zip === "") {
      isError = true;
      errors.zipError = errmsg4;
    }
    if (zip !== "" && !zipreg.test(zip)) {
      isError = true;
      errors.zipError = errmsg5;
    }
    if (this.state.flag === 0) {
      isError = true;
      errors.locationError = errmsg;
    }

    this.setState({
      ...this.state,
      ...errors,
    });

    return isError;
  };

  // validatebank = () => {
  //   const { bankName, acholderName, acType, acNo, ifsc, branchName } =
  //     this.state;

  //   let isError = false;

  //   let regac = /^\d{9,18}$/;

  //   const errmsg = "This field is mandatory";
  //   const errmsg1 = "Please enter a valid account number";

  //   const errors = {
  //     bankNameError: "",
  //     acholderNameError: "",
  //     acTypeError: "",
  //     acNoError: "",
  //     ifscError: "",
  //     branchNameError: "",
  //   };

  //   if (bankName === "") {
  //     isError = true;
  //     errors.bankNameError = errmsg;
  //   }
  //   if (acholderName === "") {
  //     isError = true;
  //     errors.acholderNameError = errmsg;
  //   }
  //   if (acType === "") {
  //     isError = true;
  //     errors.acTypeError = errmsg;
  //   }
  //   if (acNo === "") {
  //     isError = true;
  //     errors.acNoError = errmsg;
  //   }
  //   if (acNo !== "" && !regac.test(acNo)) {
  //     isError = true;
  //     errors.acNoError = errmsg1;
  //   }
  //   if (ifsc === "") {
  //     isError = true;
  //     errors.ifscError = errmsg;
  //   }
  //   if (branchName === "") {
  //     isError = true;
  //     errors.branchNameError = errmsg;
  //   }

  //   this.setState({
  //     ...this.state,
  //     ...errors,
  //   });

  //   return isError;
  // };

  validatebank = () => {
    return false;
  };
  gotobusinesspage = () => {
    document.getElementById("businessdiv").style.display = "block";
    document.getElementById("locationdiv").style.display = "none";
    document.getElementById("workingdiv").style.display = "none";
    document.getElementById("bankdiv").style.display = "none";
    this.setState({
      ...this.state,
      currentstep: 0,
    });
  };

  gotoLocationpage = () => {
    const validate1 = this.validatebusiness();

    if (!validate1) {
      document.getElementById("businessdiv").style.display = "none";
      document.getElementById("locationdiv").style.display = "block";
      document.getElementById("workingdiv").style.display = "none";
      document.getElementById("bankdiv").style.display = "none";
      this.setState({
        ...this.state,
        currentstep: 1,
      });
    }
  };

  gotoWorkingdays = () => {
    const validate2 = this.validatelocation();

    if (!validate2) {
      document.getElementById("businessdiv").style.display = "none";
      document.getElementById("locationdiv").style.display = "none";
      document.getElementById("workingdiv").style.display = "block";
      document.getElementById("bankdiv").style.display = "none";
      this.setState({
        ...this.state,
        currentstep: 2,
      });
    }
  };

  gotoBanking = () => {
    document.getElementById("businessdiv").style.display = "none";
    document.getElementById("locationdiv").style.display = "none";
    document.getElementById("workingdiv").style.display = "none";
    document.getElementById("bankdiv").style.display = "block";
    this.setState({
      ...this.state,
      currentstep: 3,
    });
  };

  updateprofilevalues = async () => {
    await Object.keys(this.state.workingHrs).map(
      (item, i) =>
        this.state.workingHrs[item].isWorking &&
        this.setState(
          (prevState) => ({
            duplicateworkingHrs: {
              ...prevState.duplicateworkingHrs,
              [item]: {
                ...prevState.duplicateworkingHrs[item],
                open: prevState.workingHrs[item].openmin,
                close: prevState.workingHrs[item].closemin,
              },
            },
          }),
          () => {},
        ),
    );
    this.sendData();
  };

  sendData = () => {
    let geo =
      this.state.lat && this.state.longi
        ? [this.state.longi, this.state.lat]
        : [];

    // const data = {
    //   orgname: this.state.orgname,
    //   licenceNo: this.state.licencenum,
    //   licenceNo2: this.state.licencenum2,
    //   weburl: this.state.weburl,
    //   storeEmail: this.state.storeEmail,
    //   contPerson: this.state.contPerson,
    //   mobile: this.state.mobile,
    //   file: this.state.file,
    //   addr1: this.state.addr1,
    //   addr2: this.state.addr2,
    //   landmark: this.state.landmark,
    //   city: this.state.city,
    //   zip: this.state.zip,
    //   district: this.state.district,
    //   states: this.state.states,
    //   credit: this.state.credit ? this.state.credit : 0,
    //   geo: geo,
    //   gstin: this.state.gst,
    //   bankName: this.state.bankName,
    //   acholderName: this.state.acholderName,
    //   acType: this.state.acType,
    //   acNo: this.state.acNo,
    //   ifsc: this.state.ifsc,
    //   branchName: this.state.branchName,
    //   branchAddr: this.state.branchAddr,
    //   workingHrs: this.state.duplicateworkingHrs,
    // };
    const data = {
      orgname: this.state.orgname,
      licenceNo: this.state.licencenum,
      licenceNo2: this.state.licencenum2,
      weburl: this.state.weburl,
      storeEmail: this.state.storeEmail,
      contPerson: this.state.contPerson,
      mobile: this.state.mobile,
      file: this.state.file,
      addr1: this.state.addr1,
      addr2: this.state.addr2,
      landmark: this.state.landmark,
      city: this.state.city,
      zip: this.state.zip,
      district: this.state.district,
      states: this.state.states,
      credit: this.state.credit ? this.state.credit : 0,
      geo: geo,
      gstin: this.state.gst,
      workingHrs: this.state.duplicateworkingHrs,
    };

    // Only attach bank details if bank is selected
    if (this.state.bankName) {
      data.bankName = this.state.bankName;
      data.acholderName = this.state.acholderName;
      data.acType = this.state.acType;
      data.acNo = this.state.acNo;
      data.ifsc = this.state.ifsc;
      data.branchName = this.state.branchName;
      data.branchAddr = this.state.branchAddr;
    }
    this.props.createOrgProfile(data);

    // const validate3 = this.validatebank();
    // if (!validate3) {
    //   this.props.createOrgProfile(data);
    // }
  };

  uploadSingleFile = (e) => {
    this.setState({
      // file: URL.createObjectURL(e.target.files[0])
      fileImg: URL.createObjectURL(e.target.files[0]),
      file: e.target.files[0],
    });
  };

  render() {
    //console.log(this.props.banks);
    let user = JSON.parse(localStorage.getItem("userDetails"));

    let districtList = this.props.districts && this.props.districts;
    let imgPreview;
    if (this.state.fileImg) {
      imgPreview = <img src={this.state.fileImg} alt="" />;
    }
    return (
      <div style={{ backgroundColor: "white", paddingBottom: "50px" }}>
        <Navbar></Navbar>
        <Modal
          show={this.state.showModal}
          size="lg"
          backdrop="static"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Body style={{ textAlign: "center" }}>
            <h4 style={{ fontWeight: "bold", color: "rgba(183, 51, 55, 1)" }}>
              Please provide us with some details, which is required to proceed
              further{" "}
            </h4>
            <Button
              style={{ backgroundColor: "#1768b7", marginTop: "10px" }}
              onClick={this.closeModal}
            >
              Continue
            </Button>
          </Modal.Body>
        </Modal>

        <div id="overlayDiv"></div>
        <div>
          <Stepper
            steps={this.state.steps}
            activeStep={this.state.currentstep}
            activeColor="#1768b7"
            completeColor="#1768b7"
            completeBarColor="#1768b7"
          />
        </div>

        <div id="businessdiv" className="updateprofilediv">
          <Card className="updateprofilecard">
            <Card.Header
              className="updateprofilehd d-flex justify-content-center align-items-center"
              style={{
                backgroundColor: "#1768b7",
                minHeight: "60px",
              }}
            >
              <Form>
                <Row>
                  <Col xs={6} sm={6} md={3} lg={3}>
                    <Row style={{ alignItems: "center" }}>
                      <Col
                        xs={12}
                        className="d-flex justify-content-center align-items-center"
                      >
                        <Form.Group className="m-0">
                          <div style={{ position: "relative" }}>
                            {/* Profile Image */}
                            <img
                              src={
                                this.state.fileImg
                                  ? this.state.fileImg
                                  : require("../../assets/img/userImg.png")
                              }
                              alt="Profile"
                              style={{
                                width: "50px",
                                height: "50px",
                                minWidth: "50px",
                                minHeight: "50px",
                                maxWidth: "50px",
                                maxHeight: "50px",
                                borderRadius: "50%",
                                objectFit: "cover",
                                display: "block",
                              }}
                            />

                            {/* Hidden input */}
                            <input
                              type="file"
                              accept="image/*"
                              id="profileImgUpload"
                              hidden
                              onChange={this.uploadSingleFile}
                            />

                            {/* Camera Icon */}
                            <label
                              htmlFor="profileImgUpload"
                              style={{
                                position: "absolute",
                                bottom: -4,
                                right: -4,
                                width: 24,
                                height: 24,
                                backgroundColor: "#1768b7",
                                borderRadius: "50%",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                cursor: "pointer",
                                border: "2px solid #fff",
                              }}
                            >
                              <i
                                className="fa fa-camera"
                                style={{ color: "#fff", fontSize: 11 }}
                              />
                            </label>
                          </div>
                        </Form.Group>
                      </Col>

                      {/* <Col xs={6} sm={6} md={6} lg={6}>
                        <Form.Group>
                          <Form.File
                            style={{ width: "90px" }}
                            id="exampleFormControlFile1"
                            name="img"
                            type="file"
                            accept="image/*"
                            onChange={this.uploadSingleFile}
                          />
                        </Form.Group>
                      </Col> */}
                    </Row>
                  </Col>
                </Row>
              </Form>
            </Card.Header>

            <Card.Body>
              <div>
                <hr style={{ backgroundColor: "#e4e5e6" }} />
              </div>
              <Form>
                <Row>
                  <Col xs={12} sm={12} md={6} lg={4}>
                    <Form.Group>
                      <div
                        className={`float-field ${this.state.orgname ? "has-value" : ""}`}
                      >
                        <Form.Control
                          type="text"
                          name="orgName"
                          value={this.state.orgname}
                          onChange={this.onChange}
                          autoComplete="off"
                        />
                        <label>
                          Organization Name <span>*</span>
                        </label>
                      </div>
                      {this.state.orgnameError && (
                        <div className="errStyle">
                          {this.state.orgnameError}
                        </div>
                      )}
                    </Form.Group>
                  </Col>

                  <Col xs={12} sm={12} md={6} lg={4}>
                    <Form.Group>
                      <div
                        className={`float-field ${this.state.weburl ? "has-value" : ""}`}
                      >
                        <Form.Control
                          type="text"
                          name="webSite"
                          value={this.state.weburl}
                          onChange={this.onChange}
                        />
                        <label>Website</label>
                      </div>
                    </Form.Group>
                  </Col>

                  <Col xs={12} sm={12} md={6} lg={4}>
                    <Form.Group>
                      <div
                        className={`float-field ${this.state.storeEmail ? "has-value" : ""}`}
                      >
                        <Form.Control
                          type="text"
                          name="storeEmail"
                          value={this.state.storeEmail}
                          onChange={this.onChange}
                        />
                        <label>
                          Email ID <span>*</span>
                        </label>
                      </div>
                      {this.state.storeEmailError && (
                        <div className="errStyle">
                          {this.state.storeEmailError}
                        </div>
                      )}
                    </Form.Group>
                  </Col>

                  
                </Row>

                <Row className="mt-3">
                  <Col xs={12} sm={12} md={6} lg={4}>
                    <Form.Group>
                      <div
                        className={`float-field ${this.state.mobile ? "has-value" : ""}`}
                      >
                        <Form.Control
                          type="text"
                          name="mobile"
                          value={this.state.mobile}
                          onChange={this.onChange}
                        />
                        <label>
                          Contact Number <span>*</span>
                        </label>
                      </div>
                      {this.state.mobileError && (
                        <div className="errStyle">{this.state.mobileError}</div>
                      )}
                    </Form.Group>
                  </Col>

                  <Col xs={12} sm={12} md={6} lg={4}>
                    <Form.Group>
                      <div
                        className={`float-field ${
                          this.state.licencenum ? "has-value" : ""
                        }`}
                      >
                        <Form.Control
                          type="text"
                          autoComplete="off"
                          name="licenceNum"
                          value={this.state.licencenum}
                          onChange={this.onChange}
                        />
                        <label>
                          Drug License (20B) <span>*</span>
                        </label>
                      </div>
                      {this.state.licencenumError && (
                        <div className="errStyle">
                          {this.state.licencenumError}
                        </div>
                      )}
                    </Form.Group>
                  </Col>

                  <Col xs={12} sm={12} md={6} lg={4}>
                    <Form.Group>
                      <div
                        className={`float-field ${
                          this.state.licencenum2 ? "has-value" : ""
                        }`}
                      >
                        <Form.Control
                          type="text"
                          autoComplete="off"
                          name="licenceNum2"
                          value={this.state.licencenum2}
                          onChange={this.onChange}
                        />
                        <label>
                          Drug License (21B) <span>*</span>
                        </label>
                      </div>
                      {this.state.licencenum2Error && (
                        <div className="errStyle">
                          {this.state.licencenum2Error}
                        </div>
                      )}
                    </Form.Group>
                  </Col>

                  
                  
                </Row>

                <Row className="mt-3">
                  <Col xs={12} sm={12} md={6} lg={4}>
                    <Form.Group>
                      <div
                        className={`float-field ${
                          this.state.gst ? "has-value" : ""
                        }`}
                      >
                        <Form.Control
                          type="text"
                          autoComplete="off"
                          name="gstin"
                          value={this.state.gst}
                          onChange={this.onChange}
                        />
                        <label>
                          GSTIN <span>*</span>
                        </label>
                      </div>
                      {this.state.gstError && (
                        <div className="errStyle">{this.state.gstError}</div>
                      )}
                    </Form.Group>
                  </Col>

                  <Col xs={12} sm={12} md={6} lg={4}>
                    <Form.Group>
                      <div
                        className={`float-field ${
                          this.state.credit ? "has-value" : ""
                        }`}
                      >
                        <Form.Control
                          type="number"
                          autoComplete="off"
                          name="credit"
                          min={0}
                          step={10}
                          value={this.state.credit}
                          onChange={this.onChange}
                        />
                        <label>Credit Period</label>
                      </div>
                    </Form.Group>
                  </Col>

                  <Col xs={12} sm={12} md={6} lg={4}>
                    <Form.Group>
                      <div
                        className={`float-field ${
                          this.state.contPerson ? "has-value" : ""
                        }`}
                      >
                        <Form.Control
                          type="text"
                          name="contPerson"
                          value={this.state.contPerson}
                          onChange={this.onChange}
                          autoComplete="off"
                        />
                        <label>
                          Contact Person <span>*</span>
                        </label>
                      </div>

                      {this.state.contPersonError && (
                        <div className="errStyle">
                          {this.state.contPersonError}
                        </div>
                      )}
                    </Form.Group>
                  </Col>
                </Row>

                {/* <Row>
                  <Col xs={12} sm={12} md={3} lg={3}>
                    <Form.Group controlId="dlry">
                        <Form.Label>Store Delivery</Form.Label><br/>
                        <Form.Check inline label="Yes" type="radio" checked ={this.state.homedelivery===true} name="homedel" onChange={this.onChange}/>
                        <Form.Check inline label="No" type="radio" checked={this.state.homedelivery===false} name="homedel" onChange={this.onChange}/>
                      </Form.Group>
                  </Col>
                </Row> */}
              </Form>
            </Card.Body>

            <Card.Footer style={{ backgroundColor: "#fff" }}>
              <Button
                className="queryBtn1"
                onClick={this.gotoLocationpage}
                style={{ float: "right" }}
              >
                <span>Save and Proceed</span>
              </Button>
            </Card.Footer>
          </Card>
        </div>

        <div id="locationdiv" className="updateprofilediv">
          <Card className="updateprofilecard">
            <Card.Body>
              <div>
                <hr style={{ backgroundColor: "#e4e5e6" }} />
              </div>
              <Form>
                <Row className="mt-3">
                  {/* Location */}
                  <Col xs={12} sm={12} md={6} lg={3}>
                    <Form.Group>
                      <div
                        className={`float-field ${
                          this.state.location ? "has-value" : ""
                        }`}
                      >
                        <PlacesAutocomplete
                          value={this.state.location}
                          onChange={this.onLocationChange}
                          onSelect={this.handleSelect}
                        >
                          {({
                            getInputProps,
                            suggestions,
                            getSuggestionItemProps,
                            loading,
                          }) => (
                            <>
                              <input
                                {...getInputProps({
                                  className: "form-control",
                                  autoComplete: "off",
                                })}
                              />
                              <label>
                                Location <span>*</span>
                              </label>

                              {suggestions.length > 0 && (
                                <div className="autocomplete-dropdown">
                                  {loading && (
                                    <div className="px-2">Loading...</div>
                                  )}
                                  {suggestions.map((suggestion, i) => (
                                    <div
                                      key={i}
                                      {...getSuggestionItemProps(suggestion, {
                                        className: `autocomplete-item ${
                                          suggestion.active ? "active" : ""
                                        }`,
                                      })}
                                    >
                                      {suggestion.description}
                                    </div>
                                  ))}
                                </div>
                              )}
                            </>
                          )}
                        </PlacesAutocomplete>
                      </div>

                      {this.state.addr1Error && (
                        <div className="errStyle">{this.state.addr1Error}</div>
                      )}
                    </Form.Group>
                  </Col>

                  {/* Address */}
                  <Col xs={12} sm={12} md={6} lg={3}>
                    <Form.Group>
                      <div
                        className={`float-field ${
                          this.state.addr2 ? "has-value" : ""
                        }`}
                      >
                        <Form.Control
                          type="text"
                          name="addr2"
                          value={this.state.addr2}
                          onChange={this.onChange}
                          autoComplete="off"
                        />
                        <label>Address</label>
                      </div>
                    </Form.Group>
                  </Col>

                  {/* Landmark */}
                  <Col xs={12} sm={12} md={6} lg={3}>
                    <Form.Group>
                      <div
                        className={`float-field ${
                          this.state.landmark ? "has-value" : ""
                        }`}
                      >
                        <Form.Control
                          type="text"
                          name="landmark"
                          value={this.state.landmark}
                          onChange={this.onChange}
                          autoComplete="off"
                        />
                        <label>Landmark</label>
                      </div>
                    </Form.Group>
                  </Col>

                  {/* State */}
                  <Col xs={12} sm={12} md={6} lg={3}>
                    <Form.Group>
                      <div
                        className={`float-field ${
                          this.state.states ? "has-value" : ""
                        }`}
                      >
                        <Form.Control
                          as="select"
                          name="states"
                          value={this.state.states}
                          onChange={this.onChange}
                        >
                          <option value=""></option>
                          {this.props.states &&
                            this.props.states.map((item, i) => (
                              <option key={i} value={item.id}>
                                {item.name}
                              </option>
                            ))}
                        </Form.Control>
                        <label>
                          State <span>*</span>
                        </label>
                      </div>

                      {this.state.statesError && (
                        <div className="errStyle">{this.state.statesError}</div>
                      )}
                    </Form.Group>
                  </Col>
                </Row>

                <Row className="mt-3">
                  {/* District */}
                  <Col xs={12} sm={12} md={6} lg={3}>
                    <Form.Group>
                      <div
                        className={`float-field ${
                          this.state.district ? "has-value" : ""
                        }`}
                      >
                        <Form.Control
                          as="select"
                          name="district"
                          value={this.state.district}
                          onChange={this.onChange}
                        >
                          <option value=""></option>
                          {districtList &&
                            districtList.map((item, i) => (
                              <option key={i} value={item.id}>
                                {item.name}
                              </option>
                            ))}
                        </Form.Control>
                        <label>
                          District <span>*</span>
                        </label>
                      </div>

                      {this.state.districtError && (
                        <div className="errStyle">
                          {this.state.districtError}
                        </div>
                      )}
                    </Form.Group>
                  </Col>

                  {/* City */}
                  <Col xs={12} sm={12} md={6} lg={3}>
                    <Form.Group>
                      <div
                        className={`float-field ${
                          this.state.city ? "has-value" : ""
                        }`}
                      >
                        <Form.Control
                          type="text"
                          name="city"
                          value={this.state.city}
                          onChange={this.onChange}
                          autoComplete="off"
                        />
                        <label>
                          City <span>*</span>
                        </label>
                      </div>

                      {this.state.cityError && (
                        <div className="errStyle">{this.state.cityError}</div>
                      )}
                    </Form.Group>
                  </Col>

                  {/* Pincode */}
                  <Col xs={12} sm={12} md={6} lg={3}>
                    <Form.Group>
                      <div
                        className={`float-field ${
                          this.state.zip ? "has-value" : ""
                        }`}
                      >
                        <Form.Control
                          type="text"
                          name="zip"
                          value={this.state.zip}
                          onChange={this.onChange}
                          autoComplete="off"
                        />
                        <label>
                          Pincode <span>*</span>
                        </label>
                      </div>

                      {this.state.zipError && (
                        <div className="errStyle">{this.state.zipError}</div>
                      )}
                    </Form.Group>
                  </Col>
                </Row>
              </Form>
            </Card.Body>

            <Card.Footer style={{ backgroundColor: "#fff" }}>
              <Button
                className="queryBtn1"
                onClick={this.gotoWorkingdays}
                //onClick={this.gotoBanking}
                style={{ float: "right" }}
              >
                <span>Save and Proceed</span>
              </Button>
              <Button
                className="leftBtn"
                onClick={this.gotobusinesspage}
                style={{ float: "left" }}
              >
                <span>Previous page</span>
              </Button>
            </Card.Footer>
          </Card>
        </div>

        <div id="workingdiv">
          <Card className="updateprofilecard">
            <Card.Body>
              <Form>
                <Row>
                  <Table borderless hover size="sm">
                    <tr>
                      <th></th>
                      <th>Day</th>
                      <th>Opening Time</th>
                      <th>Closing Time</th>
                    </tr>
                    {Object.keys(this.state.workingHrs).map((item, i) => (
                      <tr>
                        <td>
                          <input
                            type="checkbox"
                            checked={this.state.workingHrs[item].isWorking}
                            onClick={(e) => this.oncheckChange(e, item)}
                          />
                        </td>
                        <td>{this.state.workingHrs[item].showDay}</td>
                        <td>
                          <TimePicker
                            format="hh:mm a"
                            clockIcon={null}
                            disableClock={true}
                            clearIcon={null}
                            value={this.state.workingHrs[item].open}
                            onChange={(e) =>
                              this.ontimeChange(e, item, "open", "openmin")
                            }
                          />
                        </td>
                        <td>
                          <TimePicker
                            format="hh:mm a"
                            clockIcon={null}
                            disableClock={true}
                            clearIcon={null}
                            value={this.state.workingHrs[item].close}
                            onChange={(e) =>
                              this.ontimeChange(e, item, "close", "closemin")
                            }
                          />
                        </td>
                      </tr>
                    ))}
                  </Table>
                </Row>
              </Form>
            </Card.Body>
            <Card.Footer style={{ backgroundColor: "#fff" }}>
              <Button
                className="queryBtn1"
                onClick={this.gotoBanking}
                style={{ float: "right" }}
              >
                <span>Save and Proceed</span>
              </Button>
              <Button
                className="leftBtn"
                onClick={this.gotoLocationpage}
                style={{ float: "left" }}
              >
                <span>Previous page</span>
              </Button>
            </Card.Footer>
          </Card>
        </div>

        <div id="bankdiv">
          <Card className="updateprofilecard">
            <Card.Body>
              <div>
                <hr style={{ backgroundColor: "#e4e5e6" }} />
              </div>
              <Form>
                <Row className="mt-3">
                  {/* Bank */}
                  <Col xs={12} sm={12} md={6} lg={3}>
                    <Form.Group>
                      <div
                        className={`float-field ${
                          this.state.bankName ? "has-value" : ""
                        }`}
                      >
                        <Form.Control
                          as="select"
                          name="banks"
                          value={this.state.bankName}
                          onChange={this.onChange}
                        >
                          <option value=""></option>
                          {this.props.banks &&
                            this.props.banks.map((item, i) => (
                              <option key={i} value={item.id}>
                                {item.name}
                              </option>
                            ))}
                        </Form.Control>
                        <label>Select your bank</label>
                      </div>

                      {this.state.bankNameError && (
                        <div className="errStyle">
                          {this.state.bankNameError}
                        </div>
                      )}
                    </Form.Group>
                  </Col>

                  {/* Account Holder Name */}
                  <Col xs={12} sm={12} md={6} lg={3}>
                    <Form.Group>
                      <div
                        className={`float-field ${
                          this.state.acholderName ? "has-value" : ""
                        }`}
                      >
                        <Form.Control
                          type="text"
                          name="acholderName"
                          value={this.state.acholderName}
                          onChange={this.onChange}
                          autoComplete="off"
                        />
                        <label>Account Holder Name</label>
                      </div>

                      {this.state.acholderNameError && (
                        <div className="errStyle">
                          {this.state.acholderNameError}
                        </div>
                      )}
                    </Form.Group>
                  </Col>

                  {/* Account Type */}
                  <Col xs={12} sm={12} md={6} lg={3}>
                    <Form.Group>
                      <div
                        className={`float-field ${
                          this.state.actype ? "has-value" : ""
                        }`}
                      >
                        <Form.Control
                          as="select"
                          name="actype"
                          value={this.state.actype}
                          onChange={this.onChange}
                        >
                          <option value=""></option>
                          <option value="saving">Savings</option>
                          <option value="current">Current</option>
                        </Form.Control>
                        <label>Account Type</label>
                      </div>

                      {this.state.acTypeError && (
                        <div className="errStyle">{this.state.acTypeError}</div>
                      )}
                    </Form.Group>
                  </Col>

                  {/* Account No */}
                  <Col xs={12} sm={12} md={6} lg={3}>
                    <Form.Group>
                      <div
                        className={`float-field ${
                          this.state.acNo ? "has-value" : ""
                        }`}
                      >
                        <Form.Control
                          type="text"
                          name="acno"
                          value={this.state.acNo}
                          onChange={this.onChange}
                          autoComplete="off"
                        />
                        <label>Account No</label>
                      </div>

                      {this.state.acNoError && (
                        <div className="errStyle">{this.state.acNoError}</div>
                      )}
                    </Form.Group>
                  </Col>
                </Row>

                <Row className="mt-3">
                  {/* IFSC */}
                  <Col xs={12} sm={12} md={6} lg={3}>
                    <Form.Group>
                      <div
                        className={`float-field ${
                          this.state.ifsc ? "has-value" : ""
                        }`}
                      >
                        <Form.Control
                          type="text"
                          name="ifsc"
                          value={this.state.ifsc}
                          onChange={this.onChange}
                          autoComplete="off"
                        />
                        <label>IFSC</label>
                      </div>

                      {this.state.ifscError && (
                        <div className="errStyle">{this.state.ifscError}</div>
                      )}
                    </Form.Group>
                  </Col>

                  {/* Branch Name */}
                  <Col xs={12} sm={12} md={6} lg={3}>
                    <Form.Group>
                      <div
                        className={`float-field ${
                          this.state.branchName ? "has-value" : ""
                        }`}
                      >
                        <Form.Control
                          type="text"
                          name="branchname"
                          value={this.state.branchName}
                          onChange={this.onChange}
                          autoComplete="off"
                        />
                        <label>Branch Name</label>
                      </div>

                      {this.state.branchNameError && (
                        <div className="errStyle">
                          {this.state.branchNameError}
                        </div>
                      )}
                    </Form.Group>
                  </Col>

                  {/* Branch Address */}
                  <Col xs={12} sm={12} md={6} lg={3}>
                    <Form.Group>
                      <div
                        className={`float-field ${
                          this.state.branchAddr ? "has-value" : ""
                        }`}
                      >
                        <Form.Control
                          type="text"
                          name="branchaddr"
                          value={this.state.branchAddr}
                          onChange={this.onChange}
                          autoComplete="off"
                        />
                        <label>Branch Address</label>
                      </div>
                    </Form.Group>
                  </Col>
                </Row>
              </Form>
            </Card.Body>

            <Card.Footer style={{ backgroundColor: "#fff" }}>
              <Button
                className="queryBtn1"
                onClick={this.updateprofilevalues}
                style={{ float: "right" }}
              >
                Submit
              </Button>
              <Button
                className="leftBtn"
                //onClick={this.gotoWorkingdays}
                onClick={this.gotoWorkingdays}
                style={{ float: "left" }}
              >
                <span>Previous page</span>
              </Button>
            </Card.Footer>
          </Card>
        </div>
      </div>
    );
  }
}

/* export default GoogleApiWrapper({
  apiKey: 'AIzaSyCn8jkXfj8QyH4enxIOVmwlhFIofAiQpJs'
})(UpdateProfile);  */

export default UpdateProfile;
